module.exports = __webpack_public_path__ + "4842f012c259dd7a7c0fef94cc76a3c9.svg";